import { render, staticRenderFns } from "./ReceptionPatientView.vue?vue&type=template&id=28b8a850&scoped=true&"
import script from "./ReceptionPatientView.vue?vue&type=script&lang=ts&"
export * from "./ReceptionPatientView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8a850",
  null
  
)

export default component.exports